import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  EQRevisionDocument,
  RevisionDocumentListParams,
} from "../../models/serverModels/workOrder/EQRevisionDocument";

const rootApi = process.env.REACT_APP_API_KEY;

const revisionDocument = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: RevisionDocumentListParams
): Promise<ResponseList<EQRevisionDocument>> =>
  revisionDocument({
    url: `/RevisionList/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (
  params: RevisionDocumentListParams
): Promise<ResponseItem<EQRevisionDocument>> =>
  revisionDocument({
    url: `/Revision/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const create = async (
  params: Params.Create<EQRevisionDocument>
): Promise<ResponseItem<EQRevisionDocument>> =>
  revisionDocument({
    url: `/Revision`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  revisionDocument({
    url: `/Revision/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQRevisionDocument>
): Promise<ResponseItem<EQRevisionDocument>> =>
  revisionDocument({
    url: `/Revision/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
